import React, { useContext, useEffect, useState } from "react";
import PeopleAltIcon from "../Images/Pepole.svg";
import AssignmentTurnedInIcon from "../Images/Refrells.svg";
import LocalHospitalIcon from "../Images/Active.svg";
import "./Dashboard.css";
import { Container } from "@mui/material";
import PersonOutlineIcon from "../Images/bgwhiteperson.svg";
import Procedure from "../Images/Procedure.svg";
import Header from "../Header/Header";
import { useNavigate } from "react-router-dom";
import { apisPath, paths } from "../../utils/path";
import { CommonContext } from "../../context/CommonContext";
import { authHttp } from "../../services/commonHttpService";

const Dashboard = () => {
  const navigate = useNavigate();
  const { setIsLoading, setAlertState } = useContext(CommonContext);

  // State for dashboard counts
  const [dashboardData, setDashboardData] = useState({});

  // Fetch dashboard data
  const fetchDashboardData = async () => {
    setIsLoading(true);
    try {
      const response = await authHttp.get(apisPath?.miDashboard);

      if (response?.data?.status) {
        const counts = response?.data?.data;
        setDashboardData(counts);
      }
    } catch (error) {
      setAlertState((prev) => ({
        ...prev,
        open: true,
        title: error?.response?.data?.message || "Internal Server Error",
        btnTxt: "CLOSE",
        status: "fail",
      }));
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch dashboard data on component mount
  useEffect(() => {
    fetchDashboardData();
  }, []);

  return (
    <>
      {/* Welcome Header */}
      <Header showFullHeader={true} />
      <Container className="custom-container">
        <div className="mb-4">
          {/* <h4>
            Welcome{" "}
            <span style={{ color: "#1976d2", fontWeight: "bold" }}></span>
          </h4> */}
        </div>

        {/* Stats Section */}
        <div className="row mb-4">
          <div className="col-md-3 col-xs-6 mb-3 mb-md-0">
            <div className="bg-white box-design shadow p-3 d-flex align-items-center">
              <img
                src={PeopleAltIcon}
                alt=""
                className="me-3"
                style={{ width: "60px" }}
              />
              <div>
                <h5 className=" mb-0 text-number">
                  {dashboardData?.total_patients_mi || 0}
                </h5>
                <div className="text-tile">Total Patients</div>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-xs-6 mb-3 mb-md-0">
            <div className="bg-white box-design shadow p-3 d-flex align-items-center">
              <img
                src={AssignmentTurnedInIcon}
                alt=""
                className="me-3"
                style={{ width: "60px" }}
              />
              <div>
                <h5 className="text-number mb-0">
                  {dashboardData?.pending_referrals_mi || 0}
                </h5>
                <small className="text-tile">Pending Referrals</small>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-xs-6 mb-3 mb-md-0">
            <div className="bg-white shadow box-design p-3 d-flex align-items-center">
              <img
                src={LocalHospitalIcon}
                alt=""
                className="me-3"
                style={{ width: "57px" }}
              />
              <div>
                <h5 className="text-number mb-0">
                  {dashboardData?.active_treatments_mi || 0}
                </h5>
                <small className="text-tile">Active Treatments</small>
              </div>
            </div>
          </div>
        </div>

        {/* Dashboard Heading */}
        <div className="row">
          <div className="col-md-12 col-xs-12">
            <h6 className="text-tile mb-4 mt-2">
              Mentoring Institute Dashboard
            </h6>
          </div>
        </div>

        {/* Modules Section */}
        <div className="row">
          <div className="col-md-4 col-xs-6 mb-3">
            <div className="management-bg shadow box-design p-4 h-100">
              <div className="d-flex align-items-center gap-3 mb-3">
                <div className=" d-flex align-items-center justify-content-center">
                  <img
                    src={PersonOutlineIcon}
                    alt="Icon"
                    style={{ width: "75px" }}
                  />
                </div>
                <div>
                  <h6 className="tile-header f-20 mb-3">
                    Beneficiary Management
                  </h6>
                  <h5 className="fw-bold tile-header m-0">
                    {dashboardData?.active_patients_mi || 0}
                  </h5>
                  <small className="text-muted">Active Patients</small>
                </div>
              </div>

              <div
                onClick={() =>
                  navigate(
                    `${paths?.user?.commonPoint}${paths?.user?.beneficiaryManagement}`
                  )
                }
                className="action-box text-center mt-3"
              >
                <a className="text-decoration-none">Access Module →</a>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-xs-6 mb-3">
            <div className="procedure-bg shadow box-design p-4 h-100">
              <div className="d-flex align-items-center gap-3 mb-3">
                <div className=" d-flex align-items-center justify-content-center">
                  <img src={Procedure} alt="Icon" style={{ width: "75px" }} />
                </div>
                <div>
                  <h6 className="tile-header f-20 mb-3">
                    Treatment / Procedure
                  </h6>
                  <h5 className="fw-bold tile-header m-0">
                    {dashboardData?.active_treatments_mi || 0}
                  </h5>
                  <small className="text-muted">Active Treatemnts</small>
                </div>
              </div>

              <div
                className="action-procedure action-box text-center mt-3"
                onClick={() =>
                  navigate(
                    `${paths?.user?.commonPoint}${paths?.user?.treatmentModule}`
                  )
                }
              >
                <a className="text-decoration-none">Access Module →</a>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Dashboard;
